import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getService = async (serviceId: string) => {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .eq('id', serviceId)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetServiceById(serviceId: string | undefined) {
  return useQuery({
    queryKey: ['useGetServiceById', serviceId],
    queryFn: () => getService(serviceId || ''),
    staleTime: 0,
    enabled: !!serviceId
  })
}